import SiteLayout from '@/components/feature/SiteLayout';
import CtaSection from '@/components/feature/CtaSection';
import Hero from '@/pages/home/components/Hero';
import Marquee from '@/pages/home/components/Marquee';
import Intro from '@/pages/home/components/Intro';
import Services from '@/pages/home/components/Services';
import Process from '@/pages/home/components/Process';
import Sectors from '@/pages/home/components/Sectors';
import Values from '@/pages/home/components/Values';
import RecentWork from '@/pages/home/components/RecentWork';
import Training from '@/pages/home/components/Training';
import Gallery from '@/pages/home/components/Gallery';
import Testimonial from '@/pages/home/components/Testimonial';
import Faq from '@/pages/home/components/Faq';

export default function Home() {
  return (
    <SiteLayout>
      <Hero />
      <Marquee />
      <Intro />
      <Services />
      <Process />
      <Sectors />
      <Values />
      <RecentWork />
      <Training />
      <Gallery />
      <Testimonial />
      <Faq />
      <CtaSection />
    </SiteLayout>
  );
}